import { atom } from 'jotai';

export const siteNotificationsAtom = atom<string | null>(null);
